<template>
  <span>
      <span v-if="configurationLoad">
        <PapNavBar
          @hideSide="hideSide = $event"
          @attrSelected="attrSelected = $event"
          @returnClicked="returnClicked = $event"
          @flowChartTo="flowChartTo = $event"
          @openGoalSeek="openGoalSeek = $event"
          @openSensitivityAnalysis="openSensitivityAnalysis = $event"
          @editorMode="editorMode = $event"
          @executeSimulation="play($event)"
          :scenarioPeriod="scenarioPeriod"
          :yearPeriod="''"
          :revisionPeriod="''"
          :years="[]"
          :type="'PAP'"
          :updateInfoPCP="''">
        </PapNavBar>

        <div class="collumns">        
          <div class="collumnFlowChart" @mouseenter="hideSide">  
            <Loading2 class="loading_productionPlan" caption="Aguarde..."></Loading2>
            <PAP
              @sendInputList="callForSimulationByPAP($event)"
              :sendNodes="taskSimulation"
              :backFlowChart="returnClicked"
              :reloadNodes="objectStructure"
              :resetNodes="resetNodes"
              :flagEditMode="editorMode"
              :changeViewFlow="attrSelected"
              :flowchartTo="flowChartTo"
              :setLoading.sync="setLoading"
            />
          </div>
          
          <span class="right-left" v-if="enableLossScreen">
            <b-icon @click="openSide" icon="chevron-double-right" class="click-right rounded-circle bg-light"></b-icon>
            <b-icon @click="closeSide" icon="chevron-double-left" class="click-left rounded-circle bg-light"></b-icon>
            <b-icon @click="closeSide" @mouseenter="showSide" icon="chevron-double-left" class="click-left-stay rounded-circle bg-light"></b-icon>
          </span>
          <FormLossAndEfficiency 
            class="form-loss"
            v-if="enableLossScreen"
            :update="callReloadNodes"
            :sendInputsToSimulation="this.taskSimulation"
            @sendInputList="callForSimulationByLossForm($event)"
          />
        </div>
        
        <b-modal
          id="resultSimulation"
          size="lg"
          hide-footer
          :title="this.$t('simulacao-em-execucao')"
          :no-close-on-backdrop="true"
        >
          <SimulatorResult
            :result="result"
            @resultado="calculate($event, showLoading)"
            @closeSimulatiorResult="closeSimulatiorResult()"
            @stopSimulation="stopSimulation()"
          ></SimulatorResult>
        </b-modal>

        <b-modal id="goalSeekpap" size="lg" hide-footer :title="$t('atingir-metas')" :no-close-on-backdrop="true">
          <GoalSeek 
          :table="[]"
          :tableResultGoal="[]"
          @loadTableOutputGoal="loadTableOutput =$event"
          nameModel="goalSeekpap"
          ></GoalSeek>
        </b-modal>
          
        <b-modal id="openSensitivityAnalysisPap" size="lg" hide-footer :title="$t('analise-de-sensibilidade')" :no-close-on-backdrop="true">
          <SensitivityAnalysis 
          :table="[]"
          :tableResultSensitivityAnalysis="[]"
          @loadTableOutputSensitivityAnalysis="loadTableOutput =$event"
          nameModel="openSensitivityAnalysisPap">
          </SensitivityAnalysis>
        </b-modal>
      </span>
      <div v-else>
     {{ $t('loadConfigurations') }}
    </div>    
  </span>
</template>

<script>
import { openSide, closeSide, showSide, hideSide } from "../flowchart/utils/showAndHideSide"
import { SingletonEnginnering } from '../flowchart/nodes/_service/singletonEngineering';
import { SingletonAreas } from '../flowchart/nodes/_service/singletonAreas';
import { onEventBuss } from "@/global";
import { urlMainAPI } from "@/global";
import { PapMixin } from "../flowchart/utils/papMixin"
import { mapState } from "vuex";
import FormLossAndEfficiency from "./lossAndEfficiencyForm/formLossAndEfficiency.vue"
import SimulatorResult from "../productionPlanCreator/SimulatorResult.vue";
import PapNavBar from "./papNavBar"
import Loading2 from "../template/Loading2.vue";
import GoalSeek from '../goalSeek/GoalSeek';
import SensitivityAnalysis from '../sensitivityAnalysis/SensitivityAnalysis';
import axios from "axios";
import PAP from "../flowchart/PAP.vue";

let papContent = { onBussActivated: false, trySimulation: false }
const CancelToken = axios.CancelToken;
let executeRequest = CancelToken.source();
const refreshToken = () => {
  executeRequest = CancelToken.source();
};

export default {
  name: "PAPContent",

  components: {
    SimulatorResult,
    PAP,
    Loading2,
    PapNavBar,
    GoalSeek,
    FormLossAndEfficiency,
    SensitivityAnalysis
  },

  computed: mapState(["user"]),

  mixins: [ PapMixin ],

  provide() {
    return {
      getTablesToGoalSeek: [],
      callCalculationSimulation: this.calculate,
      setStopSimulation: {
        stopStimulation: this.stopSimulation,
        executeRequest: executeRequest,
        refreshToken: refreshToken,
      },
      stateOfSimulation: this.stateOfSimulation,
      startSimulation: this.prepareForSimulation,
      showLoading: this.showLoading,
    };
  },

  data() {
    return {
      resetNodes: 0,
      startEditMode: 0,
      onSimulation: false,
      returnClicked: 0,
      openSide: openSide, 
      closeSide: closeSide, 
      showSide: showSide, 
      hideSide: hideSide,
      editorMode: false,
      attrSelected: null,
      flowChartTo: "",
      openGoalSeek: 0,
      configurationLoad: false,
      setLoading: false,
      enableLossScreen: false,
      openSensitivityAnalysis :0,
      scenarioPeriod: null
    };
  },

  watch: {
    openGoalSeek() {
      this.$bvModal.show("goalSeekpap");
    },
    openSensitivityAnalysis(){
      this.$bvModal.show("openSensitivityAnalysisPap");
    }
  },

  methods: {
    callForSimulationByPAP(listOfInputNodes) {
      this.tableFlowChart = listOfInputNodes;
      this.papSent = true
    },

    callForSimulationByLossForm(listOfInput) {
      this.tableLossForm = listOfInput;
      this.formLossSent = true
    },

    waitAllReadyToSimulation() {
      if(this.papSent && (this.formLossSent || !this.enableLossScreen)) {
        papContent.trySimulation = false;
        this.executeSimulation();
        this.papSent = false;
        this.formLossSent = false;
      } else {
        if(papContent.trySimulation)
          setTimeout(this.waitAllReadyToSimulation, 250)
      }
    },

    prepareForSimulation() {
      papContent.trySimulation = true
      ++this.taskSimulation
      this.waitAllReadyToSimulation()
    },

    showLoading(show) {
      if(show)
        this.setLoading = null;
      this.setLoading = show
    },

    changeEditMode() {
      this.editorMode = !this.editorMode
    }, 

    async configurationIsLoaded() {
      if(SingletonEnginnering.isLoaded){
        this.configurationLoad = true;
        this.loadLossScreen();
        return;
      }
      else
        this.loadSingletonEnginnering();
      setTimeout(this.configurationIsLoaded, 1000)
    },

    async loadSingletonEnginnering() {
      let xml = localStorage.xml ? await JSON.parse(localStorage.xml) : "";
      if (xml && xml.scenarioObjectStructure && !SingletonEnginnering.isLoaded){
        SingletonEnginnering.load(xml.scenarioObjectStructure)
        this.loadLossScreen();
      }
    },

    async loadConfigurationPAP() {
      if (SingletonEnginnering.isLoaded) {
        if(!SingletonAreas.LoadedAreas())
          await SingletonAreas.LoadAreas(await this.loadAreas())
        this.showLoading(false);
      } else 
        setTimeout(() => this.loadConfigurationPAP(), 2000);
    },

    async loadAreas() {
      let areas = sessionStorage.areasFlowchart;
      if(!areas){
        const url = `${urlMainAPI}/getflowcharts`;
        await axios
          .get(url)
          .then((res) => {
            areas = res.data;
          })
          .catch();

          sessionStorage.areasFlowchart = JSON.stringify(areas)
        return areas
      }
        areas = JSON.parse(areas)
      return areas
    },

    async getEnable() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then((res) => 
        {
          this.enableLossScreen = !res.data.enableLossScreen
        }).catch();
    },

    loadLossScreen() {
      setTimeout(() => {
        let el = document.querySelector('.collumns');
        if (!this.enableLossScreen && el)
          el.style["grid-template-columns"] = "100%"
        else if (!this.enableLossScreen)
          this.loadLossScreen();
      }, 10);
    }
  },

  async created() {
    await this.getEnable();
    this.showLoading(true);
    if(!papContent.onBussActivated){
      onEventBuss("ExecuteSimulation", this.prepareForSimulation)
    }
    await this.configurationIsLoaded()
    this.showLoading(false);
    localStorage.setItem("xmlPeriod", localStorage.xmlPeriod != null ? localStorage.xmlPeriod : null);
    this.scenarioPeriod = localStorage.xmlPeriod;
  },
  

  beforeDestroy() {
    papContent.trySimulation = false;
  }
};
</script>

<style scoped>

SensitivityAnalysis
.form-loss {
  display: block;
}

.loading_productionPlan {
  display: none;
  align-items: center;
  position: fixed;
  top: 40%;
  left: 40%;
  height: 7%;
  width: 15%;
  min-width: 180px;
  min-height: 50px;
  z-index: 5;
  box-shadow: 3px 2px 7px #0008;
  background-color: rgba(255, 255, 255, 0.959);
  overflow: hidden !important;
}

.collumns {
  display: grid;
  grid-template-columns: 1fr 360px;
  width: 100%;
}

.collumnFlowChart {
  display: block;
  grid-column-start: 1;
}

.right-left{
  position: absolute;
  cursor: pointer;
  top: 49%;
  right: 362px;
}

.click-left-stay,
.click-left{
  display: none;
}

.click-right{
  display: block;
}

.topSelect {
  display: grid;
  grid-row-start: 1;
  align-content: center;
}

.expand {
  position: absolute;
  top: 25px;
  right: 25px;
  border-radius: 5px;
  height: 40px;
}

#selectVar {
  width: 280px;
}

#loading {
  top: calc(50% + -100px);
  left: calc(50% + -224px);
}

.gridInput {
  grid-row-start: 2;
}

.gridOutput {
  grid-row-start: 3;
}

.groupBtn {
  grid-row-start: 4;
  border-top: 2px solid gray;
  margin-right: 5px;
}

.inputData {
  display: grid;
  margin: auto;
}

.imgData {
  width: 45px;
}

.footerButtons {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  grid-row-start: 4;
  margin-top: 10px;
}

.footerButtons img {
  justify-content: flex-end;
  cursor: pointer;
  margin-left: 30px;
  max-height: 35px;
}

.imgPAP {
  height: 100%;
  width: 100%;
}

@media (max-width: 1200px) {
  #expand,
  #collpse,
  .right-left {
    display: none;
  }

  .form-loss{
    display: none !important;
  }

  .collumns {
    grid-template-columns: 100% !important;
    grid-column-gap: 0px;
  }

  .topSelect {
    justify-self: center;
    width: 394px;
    grid-column-start: 1;
  }

  .gridInput {
    grid-column-start: 1;
    grid-row-start: 2;
    margin: 0px 10px;
  }

  .gridOutput {
    grid-column-start: 2;
    grid-row-start: 2;
    margin: 0px 10px;
  }

  .groupBtn {
    margin-top: 10px;
    grid-column-end: span 2;
    grid-row-start: 3;
  }
}
</style>